import React from 'react';
import { Text } from '../text';
import { AnimatedTextFallback } from '../animatedFallbacks';

const LoadingFallback = () => (
  <>
    <Text>
      <AnimatedTextFallback block level={4} theme="light" />
    </Text>
    <Text>
      <AnimatedTextFallback block level={4} theme="light" />
    </Text>
  </>
);

export { LoadingFallback };